import axios from 'axios';
const resolvedBaseUrl = (typeof window !== 'undefined' && window.__APP_CONFIG__?.apiBaseUrl) ||
    process.env?.VITE_API_BASE_URL ||
    'http://localhost:8080/api/v1';
export const api = axios.create({
    baseURL: resolvedBaseUrl,
    withCredentials: true
});
export const setupApiInterceptors = (store) => {
    api.interceptors.request.use((config) => {
        const token = store.getState().auth.accessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });
};
